export default __webpack_public_path__ + "static/avanza-thumbnail-5ec3ffd66924a7a159dda4536a189133.webp";